// src/Nz.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Nz_default = createIcon({
  displayName: "Nz",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs("g", {
        children: [
          /* @__PURE__ */ jsx("rect", {
            width: "48",
            height: "32",
            x: "1",
            y: "1",
            fill: "#0070B8"
          }),
          /* @__PURE__ */ jsxs("g", {
            children: [
              /* @__PURE__ */ jsx("path", {
                fill: "#0070B8",
                fillRule: "evenodd",
                d: "M1 1v16h24V1H1Z",
                clipRule: "evenodd"
              }),
              /* @__PURE__ */ jsx("path", {
                fill: "#fff",
                d: "M3.7042 1 25 15.1972V17h-2.7042L1 2.8028V1h2.7042Z"
              }),
              /* @__PURE__ */ jsx("path", {
                fill: "#fff",
                d: "M3.7042 17 25 2.8028V1h-2.7042L1 15.1972V17h2.7042Z"
              }),
              /* @__PURE__ */ jsx("path", {
                fill: "#E6000C",
                d: "M1 1v1.2018L11.1972 9H13L1 1ZM13 9V7.7981L23.1972 1H25L13 9ZM25 17v-1.2019L14.8028 9H13l12 8ZM1 17l12-8v1.2019L2.8028 17H1Z"
              }),
              /* @__PURE__ */ jsx("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M15.5 1h-5v5.5H1v5h9.5V17h5v-5.5H25v-5h-9.5V1Z",
                clipRule: "evenodd"
              }),
              /* @__PURE__ */ jsx("path", {
                fill: "#E6000C",
                fillRule: "evenodd",
                d: "M14.5 1h-3v6.5H1v3h10.5V17h3v-6.5H25v-3H14.5V1Z",
                clipRule: "evenodd"
              })
            ]
          }),
          /* @__PURE__ */ jsx("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "m36.7562 4.483.6115 2.109h2.0717l-1.6439 1.2703.6089 2.0413-1.6566-1.2802-1.6523 1.2188.6081-1.9805-1.6431-1.2698h2.0285l.6672-2.109Zm6.6115 8.1089-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Zm-6 12-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Zm-6-10.5-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Z",
            clipRule: "evenodd"
          }),
          /* @__PURE__ */ jsx("path", {
            fill: "#E6000C",
            fillRule: "evenodd",
            d: "m36.342 6.7871-.143.1048h-1.2595l1.0298.796.0517.1626-.3717 1.2105 1.0117-.7463.1808.002 1.0089.7797-.372-1.247.052-.1616 1.0299-.7959h-1.3054l-.1441-.1082-.3673-1.2666-.4018 1.27Zm5.857 6.1048.143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Zm-6 12 .143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Zm-6-10.5.143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Z",
            clipRule: "evenodd"
          })
        ]
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Nz_default
};
